// extracted by mini-css-extract-plugin
export default {"container":"DatasetManagement_container__LkmdM","title":"DatasetManagement_title__Q2Z+q"};